import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText) 

export const initSplitText = () => {
	const splitWords = SplitText.create('[data-split-words]', {
		type: 'words',
		wordsClass: 'word++',
		aria: false
	})
}

export default () => {}